import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/marketplace/_layout/")({
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/marketplace/albums",
      search,
      replace: true,
    });
  },
});
